export default __webpack_public_path__ + "static/amazon-e3f937f84b20dbe62d65c1ce20da3f57.svg";